import ViewStockChecker from '@/views/stock/ViewStockChecker.vue'
import ViewStockController from '@/views/stock/ViewStockController.vue'
import ViewStockCheckRequests from '@/views/stock/ViewStockCheckRequests.vue'

export default [
	{
		path: '/stock/checker',
		name: 'stock-checker',
		component: ViewStockChecker,
		meta: {
			group: 'stock',
			permissions: []
		}
	},
	{
		path: '/stock/shortage-requests',
		name: 'stock-shortage-requests',
		component: ViewStockController,
		meta: {
			group: 'stock',
			permissions: []
		}
	},
	{
		path: '/stock/stock-check-requests',
		name: 'stock-check-requests',
		component: ViewStockCheckRequests,
		meta: {
			group: 'stock',
			permissions: ['view-stock-check-requests']
		}
	}
]
